import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from '../../connection.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
	selector: 'app-signup',
	templateUrl: './signup.component.html',
	styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
	lower = true; upper = true; len = true; num = true; spec = true; captchaVal = false; captcha = ''; signLoader = false; isShow = true; isShow1 = true; icon = "fa fa-eye-slash"; icon1 = "fa fa-eye-slash"; usrname = true; usrmail = false;

	constructor(private alert: ToastrService, private conn: ConnectionService, private route: Router) { }

	ngOnInit() {
	}

	typePwd(pwd) {
		if (pwd != null && pwd != undefined && pwd != "") {
			this.lower = true; this.upper = true; this.len = true; this.num = true; this.spec = true;
			let lowerChars = /[a-z]/g;
			let upperChars = /[A-Z]/g;
			let numbers = /[0-9]/g;
			let specials = /\W|_/g;
			if (pwd.length < 8) { this.len = false; return; }
			if (pwd.match(lowerChars) == null) { this.lower = false; return; }
			if (pwd.match(upperChars) == null) { this.upper = false; return; }
			if (pwd.match(numbers) == null) { this.num = false; return; }
			if (pwd.match(specials) == null) { this.spec = false; return; }
		}
	}

	naivagteExplorer(){
		this.route.navigate(['/explorer'])
	}

	resolved(res: string) {
		if (res != "") { this.captcha = res; this.captchaVal = true; }
	}

	checkemail(e) {
		if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(e)) {
			var data = { "email": e };
			this.conn.postUrl('users/find_email', data).subscribe((res: any) => {
				if (res.success == 0) { this.usrmail = false; }
				else { this.usrmail = true; }
			});
		}
	}

	submitFunc(signup: NgForm) {
		var data = signup.value;
		if (!data.agree) {
			this.alert.error("Please check the terms");
			return;
		}
		this.captcha = "";
		this.signLoader = true;
		this.conn.postUrl('users/signup', data).subscribe((res: any) => {
			if (res.status == 1) {
				this.alert.success(res.msg);
				this.route.navigate(['login']);
			} else if (res.status == 4) {
				this.alert.error(res.msg);
				this.route.navigate(['login']);
			} else {
				this.alert.error(res.msg);
			}
			signup.resetForm();
			this.signLoader = false;
		});
	}

	showPass() {
		this.isShow = (this.isShow) ? false : true;
		this.icon = (this.isShow) ? "fa fa-eye-slash" : "fa fa-eye";
	}

	showPass1() {
		this.isShow1 = (this.isShow1) ? false : true;
		this.icon1 = (this.isShow1) ? "fa fa-eye-slash" : "fa fa-eye";
	}

	removeSpace(event: any) {
		if (event.code === 'Space') {
			event.preventDefault();
		}
	}

	onInput(event: Event): void {
		const inputElement = event.target as HTMLInputElement;
		inputElement.value = inputElement.value.replace(/\s/g, ''); // Remove spaces
	}

}